import {IStoreState} from "../types";
export const getShowBanner = ({show_banner}: IStoreState) => show_banner;
